import { type MeshFormat, meshFormatFromExtension } from "~/three-d-diff/core";

// A request to open a mesh in the inline chat viewer, raised by an entity chip
// and rendered below the assistant message that referenced it.
export interface MeshViewRequest {
  resourceId: string;
  name: string;
  format: MeshFormat;
}

// The mesh format a file name can be viewed as in the in-chat 3D viewer, or
// undefined when it isn't a supported mesh. Drives the "View 3D" chip affordance.
export function viewableMeshFormat(fileName: string): MeshFormat | undefined {
  const dot = fileName.lastIndexOf(".");
  if (dot === -1) return undefined;
  return meshFormatFromExtension(fileName.slice(dot + 1));
}
